export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    var error = new Error(response.statusText)
    error.response = response
    throw error
  }
}

export function getApiHeaders(state) {
  return getApiHeadersFromToken(state.user.token)
}

export function getApiHeadersFromToken(token) {
  return {
    Authorization: `Token token="${token}"`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
}

export const simpleMDEOptions = {
  autofocus: true,
  hideIcons: [
    'fullscreen',
    'side-by-side',
    'code',
    'horizontal-rule',
    'quote',
    'heading',
    'ordered-list'
  ],
  status: false,
  placeholder: 'Type your comment here.'
}

/* istanbul ignore next */
export function getLoggingToken() {
  // TODO: base this off config/build
  var token = '5c5285ef844af9d1a54ca7f98b3f644f'

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      token = 'ee64ef89c5c3c2ea8bdd83b72f503e2f'
      break
    case 'questmaker.questforward.org':
      token = 'ee64ef89c5c3c2ea8bdd83b72f503e2f'
      break
  }

  return token
}

/* istanbul ignore next */
export function getLoggingProjectId() {
  // TODO: base this off config/build
  var projectId = 1

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      projectId = 2
      break
    case 'questmaker.questforward.org':
      projectId = 2
      break
  }

  return projectId
}

/* istanbul ignore next */
export function getBaseUrl() {
  // TODO: base this off config/build
  var baseUrl = 'https://opportunity-quest-test.herokuapp.com'

  switch (getWindowLocationHostname()) {
    case 'questmaker.questlearning.org':
      baseUrl = 'https://oefngl.net'
      break
    case 'questmaker.questforward.org':
      baseUrl = 'https://oefngl.net'
      break
  }

  return baseUrl
}

export function getApiBaseUrlWithOrg(orgId) {
  return getBaseUrl() + `/quest_maker/api/organizations/${orgId}`
}

export function getApiBaseUrl() {
  return getBaseUrl() + '/quest_maker/api/organizations/'
}

/* istanbul ignore next */
export function isLocalHost() {
  const hostname = window.location.hostname
  return !!(
    hostname === 'localhost' ||
    hostname === '[::1]' ||
    hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  )
}

export function isNullOrEmpty(val) {
  return !val || val === ''
}

/* istanbul ignore next */
export function getWindowLocationHostname() {
  return windowLocation.hostname
}

const windowLocation = {
  hostname: window.location.hostname
}

export { windowLocation }

export function getImageNameFromUrl(url) {
  return url ? url.split('/').pop() : ''
}

/* istanbul ignore next */
export function dataUriToBlob(uri) {
  var hasArrayBufferView = new Blob([new Uint8Array(100)]).size === 100
  var data = uri.split(',')[1]
  var bytes = typeof atob === 'undefined' ? window.atob(data) : atob(data)
  var buf = new ArrayBuffer(bytes.length)
  var arr = new Uint8Array(buf)
  for (var i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i)
  }

  if (!hasArrayBufferView) {
    arr = buf
  }
  var blob = new Blob([arr], { type: uri.split(';')[0].slice(5) })
  blob.slice = blob.slice || blob.webkitSlice
  return blob
}

// For finding position of newly added related quest for scroll
/* istanbul ignore next */
export function findPos(obj) {
  var curtop = 0
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop
    } while (obj === obj.offsetParent)

    return [curtop + obj.scrollHeight * 0.7]
  }
}

/* istanbul ignore next */
export function parseJSON(response) {
  // .json() is part of isomorphic-fetch responses
  return response.json()
}

export function getClassNameFromText(text) {
  return text.toLowerCase().replace(/ /g, '-').replace(/[()]/g, '')
}

export function displayNumberRoundedToTenth(number) {
  return parseFloat(number).toFixed(1)
}

export function displayNumberAsPercentage(number) {
  return `${Math.trunc(parseInt(number))}%`
}

// based on https://gist.github.com/ghinda/8442a57f22099bdb2e34
export function toFormData(obj, form, namespace) {
  let fd = form || new FormData()
  let formKey

  for (let property in obj) {
    if (obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']'
      } else {
        formKey = property
      }

      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
      } else if (obj[property] instanceof Array) {
        formKey = formKey + '[][value]'
        obj[property].forEach(element => {
          fd.append(formKey, element.value)
        })
      } else if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        toFormData(obj[property], fd, formKey)
      } else {
        // if it's a string or a File object
        fd.append(formKey, obj[property])
      }
    }
  }

  return fd
}



// WEBPACK FOOTER //
// ./src/utils/index.js